import React from 'react';
import './partnerLogoGrid.scss';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import clientConfig from '../../../client-config';

const PartnerLogoGrid = (props) => {
  const { gridData } = props;
  const renderEducationGrid = (educationGridData, layoutStyle) => {
    return (
      <>
        <div className="logo-grid-title">
          <h3>Education</h3>
        </div>
        <ul className="list-style-none logo-list">
          {educationGridData.partnerList.map((partner) => {
            return (
              <li key={Math.random().toString(36).substring(7)}>
                <div className="fit-img-height logo-img">
                  <Img
                    imgStyle={{
                      objectFit: 'contain',
                      // objectPosition: 'left',
                    }}
                    fluid={getFluidGatsbyImage(partner.imageData.webUrl, { maxWidth: 675 }, clientConfig.sanity)}
                    alt={partner.imageData.alt}
                  />
                </div>
                {layoutStyle === 'partner-logo-grid-with-desc' ? <p>{partner.description}</p> : ''}
              </li>
            );
          })}
        </ul>
      </>
    );
  };
  const renderOutreachGrid = (outreachData, layoutStyle) => {
    return (
      <>
        <div className="logo-grid-title">
          <h3>Outreach</h3>
        </div>
        <ul className="list-type-none logo-list">
          {outreachData.partnerList.map((partner) => {
            return (
              <li key={Math.random().toString(36).substring(7)}>
                <Img fluid={getFluidGatsbyImage(partner.imageData.webUrl, { maxWidth: 675 }, clientConfig.sanity)} alt={partner.imageData.alt} />
                {layoutStyle === 'partner-logo-grid-with-desc' ? <p>{partner.description}</p> : ''}
              </li>
            );
          })}
        </ul>
      </>
    );
  };
  return (
    <div className="container">
      <div
        className={`${gridData.className} ${
          typeof window !== 'undefined' && window.location.pathname === '/our-pawtners' ? 'partner-logo-grid' : 'home-logo-grid'
        }`}
      >
        {gridData.partners &&
          gridData.partners.map((partnerGrid) => {
            if (partnerGrid.partnerCategory === 'Education') {
              return (
                <div key={Math.random().toString(36).substring(7)} className="logo-grid-wrapper">
                  {renderEducationGrid(partnerGrid, gridData.className)}
                </div>
              );
            }
            if (partnerGrid.partnerCategory === 'Outreach') {
              return (
                <div key={Math.random().toString(36).substring(7)} className="logo-grid-wrapper">
                  {renderOutreachGrid(partnerGrid, gridData.className)}
                </div>
              );
            }
            return <div key={Math.random().toString(36).substring(7)} />;
          })}
      </div>
    </div>
  );
};

export default PartnerLogoGrid;
